var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	19427: {
		fallback: () => (Promise.all([__webpack_require__.e(7141), __webpack_require__.e(1340)]).then(() => (() => (__webpack_require__(31340))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	84135: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(9427), __webpack_require__.e(8146), __webpack_require__.e(3705), __webpack_require__.e(2076), __webpack_require__.e(5699)]).then(() => (() => (__webpack_require__(5699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	54089: {
		fallback: () => (Promise.all([__webpack_require__.e(9427), __webpack_require__.e(7610)]).then(() => (() => (__webpack_require__(7610))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	3561: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(8859), __webpack_require__.e(2076), __webpack_require__.e(3868)]).then(() => (() => (__webpack_require__(82945))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire/app",

	},
	24729: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(8859), __webpack_require__.e(4089), __webpack_require__.e(179)]).then(() => (() => (__webpack_require__(179))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire/app-check",

	},
	56587: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(8859), __webpack_require__.e(7484)]).then(() => (() => (__webpack_require__(77484))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire/auth",

	},
	97596: {
		fallback: () => (Promise.all([__webpack_require__.e(4049), __webpack_require__.e(2190), __webpack_require__.e(436)]).then(() => (() => (__webpack_require__(80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	14049: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(9427), __webpack_require__.e(8015)]).then(() => (() => (__webpack_require__(18015))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	70875: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(4456)]).then(() => (() => (__webpack_require__(34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	22109: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(7596), __webpack_require__.e(6039)]).then(() => (() => (__webpack_require__(36039))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	83757: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(8859), __webpack_require__.e(4786)]).then(() => (() => (__webpack_require__(44786))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire/firestore",

	},
	37337: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(8859), __webpack_require__.e(7636)]).then(() => (() => (__webpack_require__(37636))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire/functions",

	},
	84353: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(8859), __webpack_require__.e(9662), __webpack_require__.e(2076), __webpack_require__.e(6249)]).then(() => (() => (__webpack_require__(55080))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire/remote-config",

	},
	60993: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(8859), __webpack_require__.e(6841)]).then(() => (() => (__webpack_require__(36841))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire/storage",

	},
	44803: {
		fallback: () => (__webpack_require__.e(9645).then(() => (() => (__webpack_require__(49645))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.11.7",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "dayjs",

	},
	83835: {
		fallback: () => (__webpack_require__.e(5098).then(() => (() => (__webpack_require__(25098))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.4.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "graphql-request",

	},
	97250: {
		fallback: () => (__webpack_require__.e(6227).then(() => (() => (__webpack_require__(46227))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.17.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "lodash",

	},
	3032: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(7596), __webpack_require__.e(4049), __webpack_require__.e(6995), __webpack_require__.e(6526)]).then(() => (() => (__webpack_require__(66526))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@pathos/pathoslogos-ui",

	},
	76136: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(9662), __webpack_require__.e(3032), __webpack_require__.e(3776)]).then(() => (() => (__webpack_require__(53776))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@core-hr/shared",

	},
	20143: {
		fallback: () => (Promise.all([__webpack_require__.e(2190), __webpack_require__.e(2033), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(43835))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser/animations",

	},
	73948: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(570)]).then(() => (() => (__webpack_require__(570))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@core-hr/com/sdk",

	},
	28748: {
		fallback: () => (__webpack_require__.e(4518).then(() => (() => (__webpack_require__(24518))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.309.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@newrelic/browser-agent/features/logging",

	},
	52559: {
		fallback: () => (Promise.all([__webpack_require__.e(4518), __webpack_require__.e(2076), __webpack_require__.e(423)]).then(() => (() => (__webpack_require__(40423))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.309.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@newrelic/browser-agent/loaders/browser-agent",

	},
	77399: {
		fallback: () => (Promise.all([__webpack_require__.e(7141), __webpack_require__.e(3620)]).then(() => (() => (__webpack_require__(23620))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	27409: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(52867))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	43825: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(85689))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	88859: {
		fallback: () => (Promise.all([__webpack_require__.e(2311), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(12531))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire",

	},
	92311: {
		fallback: () => (Promise.all([__webpack_require__.e(8146), __webpack_require__.e(3705), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	62033: {
		fallback: () => (Promise.all([__webpack_require__.e(1351), __webpack_require__.e(1147)]).then(() => (() => (__webpack_require__(91147))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",

	},
	79317: {
		fallback: () => (Promise.all([__webpack_require__.e(6995), __webpack_require__.e(6569)]).then(() => (() => (__webpack_require__(16569))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "11.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@swimlane/ngx-graph",

	},
	82455: {
		fallback: () => (__webpack_require__.e(8317).then(() => (() => (__webpack_require__(8317))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "encoding-japanese",

	},
	22087: {
		fallback: () => (__webpack_require__.e(5841).then(() => (() => (__webpack_require__(85841))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "file-saver",

	},
	56995: {
		fallback: () => (Promise.all([__webpack_require__.e(1351), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(47172))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"2033": [
		62033
	],
	"2311": [
		92311
	],
	"3032": [
		3032
	],
	"3283": [
		70875,
		22109
	],
	"3561": [
		3561
	],
	"3705": [
		27409,
		43825
	],
	"3776": [
		79317,
		82455,
		22087
	],
	"4049": [
		14049
	],
	"4089": [
		54089
	],
	"4135": [
		84135
	],
	"4729": [
		24729
	],
	"6102": [
		83757,
		37337,
		84353,
		60993,
		44803,
		83835,
		97250
	],
	"6136": [
		76136
	],
	"6587": [
		56587
	],
	"6995": [
		56995
	],
	"7399": [
		77399
	],
	"7596": [
		97596
	],
	"8126": [
		20143,
		73948,
		28748,
		52559
	],
	"8859": [
		88859
	],
	"9427": [
		19427
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}